import {
	Box,
	Stack,
	TextField,
	InputAdornment,
	Button,
	Chip,
	Typography,
	Tabs,
	Tab,
} from '@mui/material'

import ClearAllIcon from '@mui/icons-material/ClearAll'
import ButtonCustom from '../atoms/button/ButtonCustom'
import styles from './listToolBar.module.scss'

import { useSelector } from 'react-redux'
import { useState } from 'react'
import { GeneralPaymentPopup } from '../../components/popups/GeneralPaymentPopup'
import { getKazooMembers } from '../../features/kazooEventSlice'
import { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useCoupleHasPremium } from '../../hooks/index.js'

export default function ListToolbar({
	title = 'List',
	searchPlaceholder = 'Search',
	searchValue,
	onSearchChange,
	chips = [],
	onClearFilters,
	onOpenFilter,
	onOpenColumns,
	onExport,
	rightSlot = null,
	showTabes = false,
	innerTab = 0,
	onInnerTabChange = () => {},
	isFiltered = true,
	isColumns = false,
	isExported = true,
	kazooId,
	searchDataCy,
	columnsDataCy,
}) {
	const hasChips = chips?.length > 0
	const inputSearchStyle = {
		minWidth: 215,
		'& .MuiInputBase-root': {
			borderRadius: '8px',
			paddingLeft: '12px',
			height: '40px',
		},
		'& .MuiInputBase-input': {
			fontSize: '12px',
			fontWeight: '400',
			color: '#000',
			fontFamily: 'Inter',
			'&::placeholder': {
				color: '#8692A4',
				opacity: 1,
			},
		},
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: '#DFE4EB',
		},
		'& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: '#DFE4EB',
		},
		'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
			{
				borderColor: '#DFE4EB',
			},
		'@media (max-width: 600px)': {
			minWidth: '100%',
		},
	}
	const inputSearchIconStyle = {
		width: '16px',
		height: '16px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		'& svg, & img': {
			width: '16px',
			height: '16px',
		},
	}
	const innerTabStyle = {
		'&.MuiTabs-root': {
			minHeight: 'unset',
			backgroundColor: '#F2F6F8',
			padding: '2px 4px',
			borderRadius: '10px',
		},
		'& .MuiTabs-scroller': {
			padding: '2px 0',
		},

		'& .MuiButtonBase-root': {
			padding: '8px',
			minHeight: 'unset',
			fontSize: '14px',
			fontFamily: 'Inter',
			fontWeight: '500',
			color: '#8692A4',
			textTransform: 'capitalize',
			minWidth: ' auto !important',

			'&.Mui-selected': {
				color: '#7CA6BD',
				backgroundColor: '#fff',
				borderRadius: '8px',
				boxShadow: '0px 1px 3px 0px #0000001A',
				minWidth: ' auto !important',

				'& svg path': {
					stroke: '#7CA6BD',
				},
			},
		},
		'& .MuiTabs-indicator': {
			backgroundColor: 'transparent',
		},
		'@media (max-width: 599px)': {
			'& .MuiButtonBase-root': {
				padding: '8px',
			},
		},
	}

	const [showUpgradePopup, setShowUpgradePopup] = useState(false)
	const dispatch = useDispatch()
    useEffect(() => {
			if (kazooId) dispatch(getKazooMembers(kazooId))
		}, [dispatch, kazooId])
	
	const kazooMembers = useSelector((s) => s.kazooEvent.kazooMembers) || {}

    const brideTier = kazooMembers?.bride?.payment
    const groomTier = kazooMembers?.groom?.payment
		
	const hasPremiumAccess = useCoupleHasPremium(brideTier, groomTier)

	const handleExportClick = () => {
        if (!hasPremiumAccess) {
            setShowUpgradePopup(true);
        } else {
            onExport?.();
        }
	};

	return (
		<div className={styles.listToolbar}>
			<div className={styles.listToolbarRow}>
				<TextField
					size="small"
					placeholder={searchPlaceholder}
					value={searchValue}
					onChange={(e) => onSearchChange?.(e.target.value)}
					sx={inputSearchStyle}
					inputProps={searchDataCy ? { 'data-cy': searchDataCy } : undefined}
					InputProps={{
						startAdornment: (
							<InputAdornment
								position="start"
								sx={inputSearchIconStyle}
							>
								<img
									src="/images/search-icon.svg"
									alt="search-icon.svg"
								/>
							</InputAdornment>
						),
					}}
				/>

				<div className={styles.filterBtns}>
					{showTabes && (
						<Tabs
							value={innerTab}
							onChange={onInnerTabChange}
							aria-label="basic tabs example"
							sx={innerTabStyle}
						>
							<Tab
								label={
									<div className={styles.tabItem}>
										<svg
											width="16"
											height="16"
											viewBox="0 0 16 16"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M13.2673 9H2.73398C1.73398 9 1.33398 9.42667 1.33398 10.4867V13.18C1.33398 14.24 1.73398 14.6667 2.73398 14.6667H13.2673C14.2673 14.6667 14.6673 14.24 14.6673 13.18V10.4867C14.6673 9.42667 14.2673 9 13.2673 9Z"
												stroke="#8692A4"
												strokeWidth="1.33"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M13.2673 1.33301H2.73398C1.73398 1.33301 1.33398 1.75967 1.33398 2.81967V5.51301C1.33398 6.57301 1.73398 6.99967 2.73398 6.99967H13.2673C14.2673 6.99967 14.6673 6.57301 14.6673 5.51301V2.81967C14.6673 1.75967 14.2673 1.33301 13.2673 1.33301Z"
												stroke="#8692A4"
												strokeWidth="1.5"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</svg>

										<span>List</span>
									</div>
								}
							/>
							<Tab
								label={
									<div className={styles.tabItem}>
										<svg
											width="16"
											height="16"
											viewBox="0 0 16 16"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M5.33398 1.33301V3.33301"
												stroke="#8692A4"
												strokeWidth="1.33"
												strokeMiterlimit="10"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M10.666 1.33301V3.33301"
												stroke="#8692A4"
												strokeWidth="1.5"
												strokeMiterlimit="10"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M2.33398 6.05957H13.6673"
												stroke="#8692A4"
												strokeWidth="1.5"
												strokeMiterlimit="10"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M14 5.66634V11.333C14 13.333 13 14.6663 10.6667 14.6663H5.33333C3 14.6663 2 13.333 2 11.333V5.66634C2 3.66634 3 2.33301 5.33333 2.33301H10.6667C13 2.33301 14 3.66634 14 5.66634Z"
												stroke="#8692A4"
												strokeWidth="1.5"
												strokeMiterlimit="10"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M10.4625 9.13314H10.4685"
												stroke="#8692A4"
												strokeWidth="2"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M10.4625 11.1331H10.4685"
												stroke="#8692A4"
												strokeWidth="2"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M7.99569 9.13314H8.00168"
												stroke="#8692A4"
												strokeWidth="2"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M7.99569 11.1331H8.00168"
												stroke="#8692A4"
												strokeWidth="2"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M5.53084 9.13314H5.53683"
												stroke="#8692A4"
												strokeWidth="2"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M5.53084 11.1331H5.53683"
												stroke="#8692A4"
												strokeWidth="2"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</svg>

										<span>Calendar</span>
									</div>
								}
							/>
						</Tabs>
					)}
					{isFiltered && (
						<ButtonCustom
							variant="outlined"
							onClick={onOpenFilter}
							style={{ minHeight: '40px' }}
						>
							<img src="/images/filter.svg" />
							<Typography variant="body">Filter</Typography>
						</ButtonCustom>
					)}
					{isColumns && (
						<ButtonCustom
							variant="outlined"
							onClick={onOpenColumns}
							style={{ minHeight: '40px' }}
							data-cy={columnsDataCy}
						>
							<img src="/images/eye-open-icon.svg" alt="" />
							<Typography variant="body">Columns</Typography>
						</ButtonCustom>
					)}
					{isExported && (
						<ButtonCustom
							variant="outlined"
							size="small"
							onClick={handleExportClick}
							style={{ minHeight: '40px' }}
						>
							<img src="/images/export.svg" />
							<Typography variant="body">Export</Typography>
						</ButtonCustom>
					)}
				</div>
				<div className={styles.filteredChips}>
					{/* <span className={styles.filteredChipsLabel}>Status:</span> */}
					{chips.map((c, i) => (
						<Chip
							key={c.key ?? i + 1}
							label={
								c.color ? (
									<Box
										sx={{
											display: 'flex',
											alignItems: 'center',
											gap: '6px',
										}}
									>
										<Box
											sx={{
												width: '8px',
												height: '8px',
												borderRadius: '50%',
												backgroundColor: c.color,
											}}
										/>
										<span>{c.label}</span>
									</Box>
								) : (
									c.label
								)
							}
							size="small"
							onDelete={c.onDelete}
							deleteIcon={
								<img src="/images/add.svg" alt="remove" />
							}
							sx={{
								'&.MuiChip-root': {
									bgcolor: '#F2F6F8',
									borderRadius: '4px',
									padding: '4px 8px',
									margin: '4px 4px 4px 0',
								},
								'& .MuiChip-label': {
									fontSize: '12px',
									fontFamily: 'Inter',
									fontWeight: '400',
									color: '#313131',
									padding: '0',
								},
								'& .MuiChip-deleteIcon': {
									color: '#7CA6BD',
									margin: '0 0 0 4px',
									width: '16px !important',
									height: '16px !important',
								},
							}}
						/>
					))}
					{/* <span className={styles.filteredChipsLabel}>Roles:</span> */}

					{hasChips && (
						<ButtonCustom
							startIcon={<ClearAllIcon />}
							size="sm"
							variant="link"
							onClick={onClearFilters}
							style={{ color: '#7CA6BD', fontWeight: '600' }}
						>
							Clear Filter
						</ButtonCustom>
					)}
				</div>

				{showUpgradePopup && (
					<GeneralPaymentPopup clickHandler={() => setShowUpgradePopup(false)}/>
					)}
				{rightSlot}
			</div>
		</div>
	)
}
